var _rect, _g, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopyDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1130_5148",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 15,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.83325,
    y: 3,
    width: 11.7222,
    height: 11.7222,
    rx: 1,
    stroke: "#666",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1130_5148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.83228 17V1H19.8323V6H6.83228V17H1.83228Z",
    fill: "#666"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.83325,
    y: 9,
    width: 12,
    height: 12,
    rx: 1,
    stroke: "#666",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyDisabled);
export default __webpack_public_path__ + "static/media/copyDisabled.dd6d02df86b8286c03c94e73262c8749.svg";
export { ForwardRef as ReactComponent };